import React from 'react';

// Placeholder for admin screens that are scaffolded in the nav but not built
// out yet (Qualification Maintenance, Drawing, Load Employees, Historic
// Reports). Keeps the routes from 404-ing and shows the planned scope.
function AdminPlaceholder({ title, note }) {
    return (
        <div style={styles.card}>
            <div style={styles.eyebrow}>Coming soon</div>
            <h2 style={styles.title}>{title}</h2>
            {note && <p style={styles.note}>{note}</p>}
        </div>
    );
}

const styles = {
    card: { background: 'white', padding: 24, borderRadius: 8, border: '1px solid #e5e7eb', maxWidth: 560 },
    eyebrow: { fontSize: 10, fontWeight: 700, color: '#9ca3af', letterSpacing: '0.1em', textTransform: 'uppercase' },
    title: { fontSize: 20, fontWeight: 800, color: '#111827', margin: '4px 0 8px' },
    note: { color: '#6b7280', fontSize: 14, lineHeight: 1.5, margin: 0 }
};

export default AdminPlaceholder;
